// extracted by mini-css-extract-plugin
export default {"wrapper":"R5vcZPNoNsaehSI0fdV8","titleContainer":"qNHJc4F7XNMo6aq6UTdk"};